import { Component, Input, OnInit } from '@angular/core';
import { ProductionManagementCounts } from 'src/app/core/interfaces/status-counts/production-management-counts';

@Component({
  selector: 'app-production-management-counts',
  templateUrl: './production-management-counts.component.html',
  styleUrls: ['./production-management-counts.component.scss'],
})
export class ProductionManagementCountsComponent implements OnInit {
  @Input() productionManagementCounts: ProductionManagementCounts;

  constructor() {}

  ngOnInit(): void {}
}
